export const genreOptions = [
    { value: "Tout", label: "Tout" },
    { value: "Action", label: "Action" },
    { value: "Animation", label: "Animation" },
    { value: "Arts Martiaux", label: "Arts Martiaux" },
    { value: "Aventure", label: "Aventure" },
    { value: "Biopic", label: "Biopic" },
    { value: "Comédie", label: "Comédie" },
    { value: "Comédie Dramatique", label: "Comédie Dramatique" },
    { value: "Comédie Musicale", label: "Comédie Musicale" },
    { value: "Drame", label: "Drame" },
    { value: "Erotique", label: "Erotique" },
    { value: "Espionnage", label: "Espionnage" },
    { value: "Famille", label: "Famille" },
    { value: "Fantastique", label: "Fantastique" },
    { value: "Guerre", label: "Guerre" },
    { value: "Historique", label: "Historique" },
    { value: "Horreur", label: "Horreur" },
    { value: "Judiciaire", label: "Judiciaire" },
    { value: "Péplum", label: "Péplum" },
    { value: "Policier", label: "Policier" },
    { value: "Romance", label: "Romance" },
    { value: "Science Fiction", label: "Science Fiction" },
    { value: "Spectacle", label: "Spectacle" },
    { value: "Thriller", label: "Thriller" },
    { value: "Western", label: "Western" },
]

const getYears = (startYear, endYear) => {
    const years = [{ value: "Tout", label: "Tout" }]

    for (let year = endYear; year >= startYear; year--) {
        years.push({ value: year, label: year })
    }

    return years
}

export const yearsOptions = getYears(1970, new Date().getFullYear())

/*
export const yearsOptions = [
    { value: "Tout", label: "Tout" },
    { value: [2020, 2029], label: "2020 - 2029" },
    { value: [2010, 2019], label: "2010 - 2019" },
    { value: [2000, 2009], label: "2000 - 2009" },
    { value: [1990, 1999], label: "1990 - 1999" },
    { value: [1980, 1989], label: "1980 - 1989" },
    { value: [1970, 1979], label: "1970 - 1979" },
    { value: [1960, 1969], label: "1960 - 1969" },
]
*/
export const paysOptions = [
    { value: "Tout", label: "Tout" },
    { value: "France", label: "France" },
    { value: "USA", label: "USA" },
    { value: "Allemagne", label: "Allemagne" },
    { value: "Chine", label: "Chine" },
    { value: "Corée du Sud", label: "Corée du Sud" },
    { value: "Danemark", label: "Danemark" },
    { value: "Espagne", label: "Espagne" },
    { value: "Finlande", label: "Finlande" },
    { value: "Grande-Bretagne", label: "Grande-Bretagne" },
    { value: "Inde", label: "Inde" },
    { value: "Italie", label: "Italie" },
    { value: "Japon", label: "Japon" },
    { value: "Mexique", label: "Mexique" },
    { value: "Norvège", label: "Norvège" },
    { value: "Pays-Bas", label: "Pays-Bas" },
    { value: "Pologne", label: "Pologne" },
    { value: "Portugal", label: "Portugal" },
    { value: "Russie", label: "Russie" },
]
